import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { SET_NAVIGATION, SET_NAVIGATION_SERVICES } from './types';
import navigationQuery from '~/graphql/navigation.gql';
export default {
  navigationBarContent(_ref, _ref2) {
    var _this = this;
    return _asyncToGenerator(function* () {
      var {
        commit,
        rootGetters
      } = _ref;
      var {
        draftId = null
      } = _ref2;
      try {
        var {
          data: {
            navigation,
            navigationServices
          }
        } = yield _this.app.apolloProvider.defaultClient.query({
          fetchPolicy: 'no-cache',
          query: navigationQuery,
          variables: _objectSpread({
            locale: rootGetters['i18n/locale'].iso
          }, draftId && {
            draftId
          })
        });
        commit(SET_NAVIGATION, navigation);
        commit(SET_NAVIGATION_SERVICES, navigationServices);
      } catch (e) {
        console.log(e);
      }
    })();
  }
};